import { useMemo } from "react";
import { useLocation } from "react-router-dom";
import queryString from "query-string";

import listSearchTag from "../listSearchTag";

export function usePesquisaPage() {
  const location = useLocation();

  const searchResult = useMemo(() => {
    const search = queryString.parse(location.search)?.search as string;
    const searchSplit = search
      ?.normalize("NFD")
      ?.replace(/[^a-zA-Z\s]/g, "")
      ?.toLocaleLowerCase()
      ?.split(" ");

    const result = listSearchTag?.reduce((previousValue, currentValue): any => {
      let isResultCorrect = false;
      searchSplit?.map((v) => {
        currentValue?.tag?.map((b) => {
          if (v?.includes(b) || b?.includes(v)) {
            b.includes(v);
            isResultCorrect = true;
          }

          return b;
        });

        return v;
      });

      if (isResultCorrect) {
        previousValue?.push(currentValue?.result);
      }

      return previousValue;
    }, [] as any);

    return result;
  }, [location]);

  const search = useMemo(() => {
    return queryString.parse(location.search)?.search;
  }, [location]);

  return { searchResult, search };
}
